var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ts-select-teacher',{model:{value:(_vm.teacher_id),callback:function ($$v) {_vm.teacher_id=$$v},expression:"teacher_id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }